import { useMemo } from 'react';

export type TimeZoneOption = {
  value: string;
  label: string;
};

const TIMEZONE_OPTIONS: TimeZoneOption[] = [
    { value: "utc-12", label: "UTC -12:00 — Baker Island" },
    { value: "utc-11", label: "UTC -11:00 — Niue" },
    { value: "utc-10", label: "UTC -10:00 — Hawaii" },
    { value: "utc-9", label: "UTC -09:00 — Alaska" },
    { value: "utc-8", label: "UTC -08:00 — Pacific Time" },
    { value: "utc-7", label: "UTC -07:00 — Mountain Time" },
    { value: "utc-6", label: "UTC -06:00 — Central Time" },
    { value: "utc-5", label: "UTC -05:00 — Eastern Time" },
    { value: "utc-4", label: "UTC -04:00 — Atlantic Time" },
    { value: "utc-3", label: "UTC -03:00 — Argentina" },
    { value: "utc-2", label: "UTC -02:00 — South Georgia" },
    { value: "utc-1", label: "UTC -01:00 — Azores" },
  
    { value: "utc+0", label: "UTC ±00:00 — London GMT" },
  
    { value: "utc+1", label: "UTC +01:00 — Central Europe" },
    { value: "utc+2", label: "UTC +02:00 — Eastern Europe" },
    { value: "utc+3", label: "UTC +03:00 — Moscow" },
    { value: "utc+4", label: "UTC +04:00 — Dubai" },
    { value: "utc+5", label: "UTC +05:00 — Pakistan" },
    { value: "utc+6", label: "UTC +06:00 — Dhaka" },
    { value: "utc+7", label: "UTC +07:00 — Bangkok" },
    { value: "utc+8", label: "UTC +08:00 — Singapore" },
    { value: "utc+9", label: "UTC +09:00 — Tokyo" },
    { value: "utc+10", label: "UTC +10:00 — Sydney" },
    { value: "utc+11", label: "UTC +11:00 — Solomon Is." },
    { value: "utc+12", label: "UTC +12:00 — Auckland" },
    { value: "utc+13", label: "UTC +13:00 — Samoa" },
    { value: "utc+14", label: "UTC +14:00 — Line Is." },
  ];
  

export const useTimeZone = () => {
  const options = useMemo(() => TIMEZONE_OPTIONS, []);

  /** Get full option from value */
  const getOptionByValue = (value?: string) =>
    options.find((tz) => tz.value === value);

  /** Get label only */
  const getLabelByValue = (value?: string) =>
    getOptionByValue(value)?.label ?? '';

  /** Convert `utc+6` → 6, `utc-5` → -5 */
  const getOffsetNumber = (value?: string) => {
    if (!value) return 0;
    return Number(value.replace('utc', ''));
  };

  /** Detect user's timezone offset */
  const getUserTimeZoneValue = () => {
    const offset = -(new Date().getTimezoneOffset() / 60);
    return `utc${offset >= 0 ? '+' : ''}${offset}`;
  };

  return {
    options, // AntD Select options
    getOptionByValue,
    getLabelByValue,
    getOffsetNumber,
    getUserTimeZoneValue,
  };
};
